import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

function CheckboxSelect({ trackID, size = 12, color = `#6A6A6A`, onClick, className, style }) {
  const active = useSelector( state => (state.selectedItems && !!state.selectedItems.find(x => x.id === trackID) ));
  return (
    <div className={className} style={{cursor: `pointer`, ...style}} onClick={onClick}>
      <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      { active
        ? <circle cx={size / 2} cy={size / 2} r={size / 2} fill="#01FF95" />
        : <circle cx={size / 2} cy={size / 2} r={size / 2} stroke={color} />
      }
      </svg>
    </div>
  )
}

CheckboxSelect.propTypes = {
  trackID: PropTypes.any.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default CheckboxSelect;
